import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  FormGroup, InputGroup, Input, InputGroupAddon, InputGroupText,
  Row, Col,
  UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import Select from 'react-select';
import { axios } from 'ApiClient';
import { useSelector } from 'react-redux';
import CheckboxFilter from '../../../../../shared/components/CheckboxFilter';
import CheckboxManyFilter from '../../../../../shared/components/CheckboxManyFilter';
import TopButtonsPeriod from '../../../../admin/Reports/TimePeriodFilterExtended';
import Stat from '../../../../../shared/components/stat';
import AccessComponent from '../../../../../shared/components/auth/AccessComponent';
import Filter from '../../../../../shared/components/filter/TimePeriodFilter';
import { countriesBH } from '../../../../../shared/helpers/WVConstants';

const initialChannelsFilters = {
  YouTube: true,
  'YouTube Description Text': true,
  'YouTube Shorts': true,
  Podcast: true,
  'Podcast Script Text': true,
  'Instagram Story': true,
  'Instagram Post': true,
  'Instagram TV Video': true,
  TikTok: true,
  'Facebook Post': true,
  'Facebook Watch Video': true,
  'Twitter Post': true,
  LinkTree: true,
  Website: true,
  Email: true,
  Text: true,
};
const specialCriteriaFilters = {
  'Oscar Worthy': true,
  'Not Oscar Worthy': true,
};
// const getFilterValueInitial = (filterType) => {
//   let initialFilterType = '<=';
//   const type = new URLSearchParams(window.location.search).get(filterType);
//   if (type) {
//     initialFilterType = type;
//   }
//   return initialFilterType;
// };

const Actions = React.memo(({
  history,
  showTable,
}) => {
  const session = useSelector(state => state.session);
  const selectedInitialRange = session.role === 'auditor' ? '7_days' : 'current_month';
  const selectedStartDateInitialState = session.role === 'auditor' ? moment().subtract(8, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss') : moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
  const selectedEndDateInitialState = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState({
    type: initialChannelsFilters,
    special: specialCriteriaFilters,
    // isFTCCompliant: {
    //   Compliant: true,
    //   'Non-Compliant': false,
    // },
  });
  const [dateSearch, setDateSearch] = useState(null);
  const [startDate, setStartDate] = useState(selectedStartDateInitialState);
  const [endDate, setEndDate] = useState(selectedEndDateInitialState);
  const [selectedButton, setSelectedButton] = useState(selectedInitialRange);
  const [url, setUrlU] = useState('');
  const [loadingTotalsUrl, setLoadingTotalsUrl] = useState(null);
  const [dateUrl, setDateUrl] = useState(null);
  const [loadingProgramCountryOptions, setLoadingProgramCountryOptions] = useState(false);
  const [programCountryOptions, setProgramCountryOptions] = useState([]);

  const loadHubilCountriesOptions = async () => {
    setLoadingProgramCountryOptions(true);
    await axios.getSafety('/api/brand/dashboard/get-program-country-options').then((data) => {
      if (data.success === true && data.options?.length > 0) {
        const co = data.options.map(option => ({ value: option.value, label: option.label }));
        co.unshift({ value: null, label: '-- Not Assigned --' });
        setProgramCountryOptions(co);
      } else {
        setProgramCountryOptions([{ value: null, label: '-- Not Assigned --' }]);
        console.log('Program Country options are not available for this moment');
      }
    }).catch((err) => {
      console.log(err);
    });
    setLoadingProgramCountryOptions(false);
  };

  useEffect(() => {
    loadHubilCountriesOptions();
  }, []);

  const countryOpt = Object.entries(countriesBH()).map(entry => ({ value: entry[0], label: entry[1] }));
  countryOpt.unshift({ value: 'null', label: '-- Not Assigned --' });
  const selectedCountries = filters?.country?.map(f => f.value) || [];
  const selectedProgramCountries = filters?.programCountry?.map(f => f.value) || [];

  const getUrlSearch = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', '1');
    if (search) {
      searchParams.set('filters.fullSearchName', search);
    } else {
      searchParams.delete('filters.fullSearchName');
    }
    let noFilter = true;
    if (filters && filters.type && Object.keys(filters.type).length > 0) {
      searchParams.delete('filters.type');
      Object.keys(filters.type).forEach((key) => {
        if (!filters.type[key]) return false;
        searchParams.append('filters.type', key);
        noFilter = false;
        return true;
      });
      if (noFilter) {
        searchParams.append('filters.type', 'none');
      } else {
        noFilter = true;
      }
    }
    if (filters && filters.special && Object.keys(filters.special).length > 0) {
      searchParams.delete('filters.special');
      Object.keys(filters.special).forEach((key) => {
        if (!filters.special[key]) return false;
        searchParams.append('filters.special', key);
        noFilter = false;
        return true;
      });
      if (noFilter) {
        searchParams.append('filters.special', 'none');
      } else {
        noFilter = true;
      }
    }
    // if (filters && filters.isFTCCompliant && Object.keys(filters.isFTCCompliant).length > 0) {
    //   searchParams.delete('filters.isFTCCompliant');
    //   Object.keys(filters.isFTCCompliant).forEach((key) => {
    //     if (!filters.isFTCCompliant[key]) return false;
    //     searchParams.append('filters.isFTCCompliant', key);
    //     noFilter = false;
    //     return true;
    //   });
    //   if (noFilter) {
    //     searchParams.append('filters.isFTCCompliant', 'none');
    //   }
    // }
    searchParams.delete('filters.programCountry');
    const programCountries = filters?.programCountry;
    if (programCountries && programCountries.length > 0) {
      programCountries.forEach((key) => {
        searchParams.append('filters.programCountry', key.value);
      });
    }
    searchParams.delete('filters.country');
    const countries = filters.country;
    if (countries && countries.length > 0) {
      countries.forEach((key) => {
        searchParams.append('filters.country', key.value);
      });
    }
    return searchParams;
  };

  const setUrl = (/* setFirstPage = false */) => {
    const urlSearch = getUrlSearch();
    urlSearch.delete('filters.publishedAt~~from');
    urlSearch.delete('filters.publishedAt~~to');
    urlSearch.delete('range');
    if (startDate !== '') {
      urlSearch.append('filters.publishedAt~~from', startDate);
    }
    if (endDate !== '') {
      urlSearch.append('filters.publishedAt~~to', endDate);
    }
    urlSearch.append('range', selectedButton);

    urlSearch.delete('filters.urlStatus');
    urlSearch.append('filters.urlStatus', 'Approved');
    urlSearch.append('filters.urlStatus', 'Not Set');
    urlSearch.delete('filters.brandStatus');
    urlSearch.append('filters.brandStatus', 'Approved');
    urlSearch.delete('filters.status');
    urlSearch.append('filters.status', 'Brand Approved');
    setUrlU(urlSearch.toString());
    setLoadingTotalsUrl(`/api/brand/content/get-video-totals?${urlSearch.toString()}`);
  };
  useEffect(() => {
    if (dateSearch) {
      clearTimeout(dateSearch);
    }
    setDateSearch(setTimeout(() => {
      setUrl();
    }, 1000));
  }, [search]);
  useEffect(() => {
    if (dateUrl) {
      clearTimeout(dateUrl);
    }
    setDateUrl(setTimeout(() => {
      setTimeout(() => showTable(true));
      history.push(`${history.location.pathname}?${url}`);
    }, 500));
  }, [url]);
  useEffect(() => {
    setUrl(true);
  }, [filters, startDate, endDate]);

  const colourStyles = {
    multiValue: styles => ({
      ...styles,
      backgroundColor: '#70bbfd',
    }),
    multiValueLabel: styles => ({
      ...styles,
      color: 'white',
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: 'white',
      ':hover': {
        backgroundColor: '#a2e1fd',
        color: '#70bbfd',
      },
    }),
  };

  return (
    <div>
      <Row>
        <Col className="ml-3">
          <AccessComponent showWhenRole={['owner']}>
            <TopButtonsPeriod
              selectedButtonInitial={selectedButton}
              startDateInitial={selectedStartDateInitialState}
              endDateInitial={selectedEndDateInitialState}
              setValue={(param, value, range) => {
                if (param === 'startDate') {
                  setStartDate(moment(value).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
                }
                if (param === 'endDate') {
                  setEndDate(moment(value).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
                }
                setSelectedButton(range);
              }}
            />
          </AccessComponent>
          <AccessComponent showWhenRole={['auditor']}>
            <Filter
              startDateInitial={selectedStartDateInitialState}
              endDateInitial={selectedEndDateInitialState}
              selectedButtonInitial={selectedButton}
              setValue={(param, value, range) => {
                if (param === 'startDate') {
                  setStartDate(moment(value).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
                }
                if (param === 'endDate') {
                  setEndDate(moment(value).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
                }
                setSelectedButton(range);
              }}
              options={[
                { value: '30_days', label: '30 Days', border: '5px 0 0 5px' },
                { value: '7_days', label: 'Last 7 Days' },
                {
                  value: 'today', label: 'Today', border: '0 5px 5px 0', lastElement: true,
                },
              ]}
              selectDateRangeFunction={(range) => {
                let dFrom;
                let dTo;
                let showCustom = false;
                switch (range) {
                  case '30_days':
                    showCustom = false;
                    dFrom = moment().subtract(31, 'days').startOf('day').toDate();
                    dTo = moment().subtract(1, 'day').endOf('day').toDate();
                    break;
                  case '7_days':
                    showCustom = false;
                    dFrom = moment().subtract(8, 'days').startOf('day').toDate();
                    dTo = moment().subtract(1, 'day').endOf('day').toDate();
                    break;
                  case 'today':
                    showCustom = false;
                    dFrom = moment().startOf('day').toDate();
                    dTo = moment().endOf('day').toDate();
                    break;
                  default:
                    dFrom = moment().startOf('day').toDate();
                    dTo = moment().endOf('day').toDate();
                    break;
                }
                // console.log({ selectedStartDateInitialState, selectedEndDateInitialState, showCustom });
                return { dateFrom: dFrom, dateTo: dTo, showCustom };
              }
              }
            />
          </AccessComponent>
        </Col>
      </Row>
      <Stat
        labels={{
          count: 'No. Videos',
          views: 'No. Views',
        }}
        url={loadingTotalsUrl}
      />
      <Row>
        <Col sm="auto">
          <div className="float-left my-1" style={{ width: '3px' }} />
          <CheckboxManyFilter
            filterProp={filters.type}
            filterTitle="Type"
            filterAction={({ data }) => setFilters(f => ({ ...f, type: data }))}
          />
          <CheckboxFilter
            filterProp={filters.special}
            filterTitle="Oscar Worthy"
            filterAction={({ data }) => setFilters(f => ({ ...f, special: data }))}
          />
        </Col>
        <Col>
          <UncontrolledButtonDropdown className="mt-2 float-right">
            <DropdownToggle caret className="mr-2 time-period-filter-buttons-extended active btn-sm" color="primary">
              Actions
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => window.open(`/resources/content/download-csv?${getUrlSearch().toString()}`, '_blank').focus()}>Download CSV</DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <InputGroup>
            <Input
              className="form-control-sm form-control ml-3"
              name="search"
              type="search"
              autoComplete="off"
              placeholder="Creator Name, Email, Title"
              value={search}
              onChange={p => setSearch(p.target.value)}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText>
                <i
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{ color: '#70bbfd', fontSize: 12 }}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Select
              isMulti
              name="programCountrySelect"
              isClearable
              value={programCountryOptions.filter(opt => selectedProgramCountries.includes(opt.value))}
              options={programCountryOptions}
              isDisabled={loadingProgramCountryOptions}
              isLoading={loadingProgramCountryOptions}
              onChange={(data) => { setFilters(f => ({ ...f, programCountry: data })); }}
              placeholder="Program Countries"
              style={{ maxHeight: '120px' }}
              styles={colourStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
              })}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Select
              isMulti
              name="countrySelect"
              isClearable
              value={countryOpt.filter(opt => selectedCountries.includes(opt.value))}
              options={countryOpt}
              onChange={(data) => { setFilters(f => ({ ...f, country: data })); }}
              placeholder="Countries"
              style={{ maxHeight: '120px' }}
              styles={colourStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
              })}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
});

Actions.propTypes = {
  showTable: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
  }).isRequired,
};
export default Actions;
